import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MessagesService } from '../messages.service';
import { PushBySender } from '../messages.types';
import { HttpService } from '../../../../core/http/http.service';

@Component({
    selector: 'messages-list',
    templateUrl: './messages-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessagesListComponent implements OnInit, OnDestroy {

    messages: PushBySender[];

    private _unsubscribeAll = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private httpService: HttpService,
        private _messagesService: MessagesService
    ) { }

    ngOnInit() {
        // Subscribe to message changes
        this._messagesService.messages$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((messages) => {

                // Load the messages
                this.messages = messages;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy() {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: PushBySender): any {
        return item.messageId || index;
    }

    getAvatarUrl(message: PushBySender) {
        const image = message.partaker.profileImage;
        return image.startsWith('http') ? image : `${this.httpService.getBaseUrl()}${image}`;
    }

}
